import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="login-footer">
      <div className="footer-links">
        <a target="_blank" href="https://seller2go.com/impressum/" rel="noopener noreferrer">{t('footerImprint')}</a>
        <a target="_blank" href="https://seller2go.com/datenschutzerklaerung/" rel="noopener noreferrer">{t('footerPrivacyPolicy')}</a>
        <a target="_blank" href="https://seller2go.com/agb/" rel="noopener noreferrer">{t('footerTerms')}</a>
        <a target="_blank" href="/partner" rel="noopener noreferrer">{t('footerPartner')}</a>
      </div>
    </footer>
  );
};